/**
 * Collapses a raw brand string (any case) onto the canonical brand key used by AEM Experience
 * Fragments, GTM container resolution, and clientlib loading:
 *
 * - `sir` / `cw` → `'sir'`
 * - `ev` / `ebac` / `wm` → `'ebac'`
 * - anything else → returned unchanged (so unknown brands are still routable / debuggable)
 *
 * Lives in its own module — separate from `aemApi.ts` — because it's a pure no-side-effects
 * switch. Pulling it via `aemApi.ts` drags in that module's session-storage cleanup pass,
 * logger init, `Cache` instances, and the `ProtectedDataStore` + env transitive imports, which
 * is real startup work for any low-level config (e.g. `configs/gtm.ts`) that just needs the
 * brand alias. `aemApi.ts` re-exports this for backwards compatibility, so existing callers
 * unaware of the split keep compiling.
 */
export function transformBrand(brand: string): string {
  switch (brand.toLowerCase()) {
    case 'sir':
    case 'cw':
      return 'sir'
    case 'ev':
    case 'ebac':
    case 'wm':
      return 'ebac'
    default:
      return brand
  }
}
